module.exports = __webpack_public_path__ + "static/utilization-product-56b114822f570d3c54c5dabdf034d5b9.svg";